// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: organization.proto

export const protobufPackage = 'compasspb';

/** InvitationStatus represents the status of an invitation */
export enum InvitationStatus {
  INVITATION_STATUS_UNSPECIFIED = 0,
  INVITATION_STATUS_PENDING = 1,
  INVITATION_STATUS_ACCEPTED = 2,
  INVITATION_STATUS_EXPIRED = 3,
  INVITATION_STATUS_REVOKED = 4,
}

/** GetCurrentUserOrganizationsRequest represents the request to retrieve organizations for the authenticated user */
export interface GetCurrentUserOrganizationsRequest {
  limit?: number | undefined;
  start_after_id?: string | undefined;
}

/** GetCurrentUserOrganizationsResponse represents the response containing organizations for the authenticated user */
export interface GetCurrentUserOrganizationsResponse {
  organizations?: Organization[] | undefined;
  /** @deprecated */
  total_count?: number | undefined;
}

/** GetOrganizationsRequest represents the request to retrieve organizations (global scope) */
export interface GetOrganizationsRequest {
  user_id?: string | undefined;
  limit?: number | undefined;
  start_after_id?: string | undefined;
}

/** GetOrganizationsResponse represents the response containing organizations and total count */
export interface GetOrganizationsResponse {
  organizations?: Organization[] | undefined;
  /** @deprecated */
  total_count?: number | undefined;
}

/**
 * Organization represents an organization entity from Auth0.
 * Organizations are top-level entities that group users, programs, and resources.
 */
export interface Organization {
  id?: string | undefined;
  name?: string | undefined;
  slug?: string | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
  excluded_roles?: string[] | undefined;
}

/**
 * InviteUserToOrganizationRequest represents the request to invite a user to an organization.
 * Creates an inactive user record and sends an Auth0 invitation if the user doesn't exist.
 * For existing users not yet members, assigns roles and sends an invitation.
 */
export interface InviteUserToOrganizationRequest {
  organization_id?: string | undefined;
  email?: string | undefined;
  name?: string | undefined;
  organization_role_id?: string | undefined;
  program_role_ids?: { [key: string]: string } | undefined;
}

export interface InviteUserToOrganizationRequest_ProgramRoleIdsEntry {
  key: string;
  value: string;
}

/**
 * InviteUserToOrganizationResponse represents the response after inviting a user to an organization.
 * Contains invitation details, user information, and role assignments.
 */
export interface InviteUserToOrganizationResponse {
  invitation_id?: string | undefined;
  user_id?: string | undefined;
  invitation_url?: string | undefined;
  user_created?: boolean | undefined;
  assigned_role_ids?: string[] | undefined;
  expires_at?: string | undefined;
}

/** GetOrganizationRequest represents the request to get a single organization */
export interface GetOrganizationRequest {
  organization_id?: string | undefined;
}

/** GetOrganizationResponse represents the response containing a single organization */
export interface GetOrganizationResponse {
  organization?: Organization | undefined;
}

/** CreateOrganizationRequest represents the request to create a new organization */
export interface CreateOrganizationRequest {
  name?: string | undefined;
  display_name?: string | undefined;
  metadata?: { [key: string]: string } | undefined;
  branding?: OrganizationBranding | undefined;
}

export interface CreateOrganizationRequest_MetadataEntry {
  key: string;
  value: string;
}

/** CreateOrganizationResponse represents the response after creating an organization */
export interface CreateOrganizationResponse {
  organization?: Organization | undefined;
}

/** OrganizationBranding represents branding settings for an organization */
export interface OrganizationBranding {
  logo_url?: string | undefined;
  colors?: { [key: string]: string } | undefined;
}

export interface OrganizationBranding_ColorsEntry {
  key: string;
  value: string;
}

/** UpdateOrganizationRequest represents the request to update an organization */
export interface UpdateOrganizationRequest {
  organization_id?: string | undefined;
  name?: string | undefined;
  display_name?: string | undefined;
  metadata?: { [key: string]: string } | undefined;
  branding?: OrganizationBranding | undefined;
  excluded_roles?: string[] | undefined;
}

export interface UpdateOrganizationRequest_MetadataEntry {
  key: string;
  value: string;
}

/** UpdateOrganizationResponse represents the response after updating an organization */
export interface UpdateOrganizationResponse {
  organization?: Organization | undefined;
}

/** DeleteOrganizationRequest represents the request to delete an organization */
export interface DeleteOrganizationRequest {
  organization_id?: string | undefined;
}

/** DeleteOrganizationResponse represents the response after deleting an organization */
export interface DeleteOrganizationResponse {
  success?: boolean | undefined;
}

/** GetOrganizationMembersRequest represents the request to get organization members */
export interface GetOrganizationMembersRequest {
  organization_id?: string | undefined;
  limit?: number | undefined;
  start_after_id?: string | undefined;
}

/** GetOrganizationMembersResponse represents the response containing organization members */
export interface GetOrganizationMembersResponse {
  members?: OrganizationMember[] | undefined;
  /** @deprecated */
  total_count?: number | undefined;
}

/** OrganizationMember represents a member of an organization */
export interface OrganizationMember {
  user_id?: string | undefined;
  email?: string | undefined;
  name?: string | undefined;
  picture?: string | undefined;
}

/** AddUserToOrganizationRequest represents the request to add a user to an organization */
export interface AddUserToOrganizationRequest {
  organization_id?: string | undefined;
  user_id?: string | undefined;
  organization_role_id?: string | undefined;
  program_role_ids?: { [key: string]: string } | undefined;
}

export interface AddUserToOrganizationRequest_ProgramRoleIdsEntry {
  key: string;
  value: string;
}

/** AddUserToOrganizationResponse represents the response after adding a user to an organization */
export interface AddUserToOrganizationResponse {
  success?: boolean | undefined;
}

/** RemoveUserFromOrganizationRequest represents the request to remove a user from an organization */
export interface RemoveUserFromOrganizationRequest {
  organization_id?: string | undefined;
  user_id?: string | undefined;
}

/** RemoveUserFromOrganizationResponse represents the response after removing a user from an organization */
export interface RemoveUserFromOrganizationResponse {
  success?: boolean | undefined;
}

/** ListOrganizationInvitationsRequest represents the request to list organization invitations */
export interface ListOrganizationInvitationsRequest {
  organization_id?: string | undefined;
  limit?: number | undefined;
  start_after_id?: string | undefined;
  /** @deprecated */
  status?: InvitationStatus | undefined;
  statuses?: InvitationStatus[] | undefined;
}

/** ListOrganizationInvitationsResponse represents the response containing organization invitations */
export interface ListOrganizationInvitationsResponse {
  invitations?: OrganizationInvitation[] | undefined;
  /** @deprecated */
  total_count?: number | undefined;
}

/** OrganizationInvitation represents an invitation to join an organization */
export interface OrganizationInvitation {
  id?: string | undefined;
  organization_id?: string | undefined;
  inviter_name?: string | undefined;
  invitee_email?: string | undefined;
  invitation_url?: string | undefined;
  created_at?: string | undefined;
  expires_at?: string | undefined;
  roles?: string[] | undefined;
  status?: InvitationStatus | undefined;
  invitee_name?: string | undefined;
}

/** GetOrganizationInvitationRequest represents the request to get a specific invitation */
export interface GetOrganizationInvitationRequest {
  organization_id?: string | undefined;
  invitation_id?: string | undefined;
}

/** GetOrganizationInvitationResponse represents the response containing a single invitation */
export interface GetOrganizationInvitationResponse {
  invitation?: OrganizationInvitation | undefined;
}

/** DeleteOrganizationInvitationRequest represents the request to delete/revoke an invitation */
export interface DeleteOrganizationInvitationRequest {
  organization_id?: string | undefined;
  invitation_id?: string | undefined;
}

/** DeleteOrganizationInvitationResponse represents the response after deleting an invitation */
export interface DeleteOrganizationInvitationResponse {
  success?: boolean | undefined;
}

/**
 * OrganizationsService provides operations for managing organizations.
 * Organizations are top-level entities that group users, programs, and resources.
 * This service handles organization CRUD, membership, and user invitations.
 */
export interface OrganizationsService {
  /**
   * Get organizations for the authenticated user
   * Retrieves organizations accessible by the authenticated user from Auth0 data
   */
  getCurrentUserOrganizations(
    request: GetCurrentUserOrganizationsRequest,
  ): Promise<GetCurrentUserOrganizationsResponse>;
  /**
   * Get organizations (admin/global access)
   * Retrieves organizations for a specified user (requires global read permission)
   */
  getOrganizations(request: GetOrganizationsRequest): Promise<GetOrganizationsResponse>;
  /** Get a single organization by ID */
  getOrganization(request: GetOrganizationRequest): Promise<GetOrganizationResponse>;
  /** Create a new organization (creates in both Auth0 and local DB) */
  createOrganization(request: CreateOrganizationRequest): Promise<CreateOrganizationResponse>;
  /** Update an existing organization */
  updateOrganization(request: UpdateOrganizationRequest): Promise<UpdateOrganizationResponse>;
  /** Delete an organization (soft delete in local DB, removes from Auth0) */
  deleteOrganization(request: DeleteOrganizationRequest): Promise<DeleteOrganizationResponse>;
  /** Get organization members */
  getOrganizationMembers(
    request: GetOrganizationMembersRequest,
  ): Promise<GetOrganizationMembersResponse>;
  /** Add a user to an organization (direct add, no invitation) */
  addUserToOrganization(
    request: AddUserToOrganizationRequest,
  ): Promise<AddUserToOrganizationResponse>;
  /** Remove a user from an organization */
  removeUserFromOrganization(
    request: RemoveUserFromOrganizationRequest,
  ): Promise<RemoveUserFromOrganizationResponse>;
  /** Invite a user to join an organization with specified roles */
  inviteUserToOrganization(
    request: InviteUserToOrganizationRequest,
  ): Promise<InviteUserToOrganizationResponse>;
  /** List pending invitations for an organization */
  listOrganizationInvitations(
    request: ListOrganizationInvitationsRequest,
  ): Promise<ListOrganizationInvitationsResponse>;
  /** Get a specific invitation */
  getOrganizationInvitation(
    request: GetOrganizationInvitationRequest,
  ): Promise<GetOrganizationInvitationResponse>;
  /** Revoke/delete an invitation */
  deleteOrganizationInvitation(
    request: DeleteOrganizationInvitationRequest,
  ): Promise<DeleteOrganizationInvitationResponse>;
}
